import { z } from 'zod';

export const demandSampleSizeBucketEnum = z.enum(['5-9', '10-24', '25-49', '50+']);

export const marketDemandProductSchema = z.object({
  normalizedName: z.string(),
  demandIndex: z.number(),
  medianPriceBand: z
    .object({
      median: z.number(),
      p25: z.number().nullable(),
      p75: z.number().nullable(),
    })
    .nullable(),
  sampleSizeBucket: demandSampleSizeBucketEnum,
});

export const marketDemandResponseSchema = z.object({
  city: z.string(),
  market: z.string(),
  category: z.string().nullable(),
  from: z.string(),
  to: z.string(),
  products: z.array(marketDemandProductSchema),
});

export type MarketDemandProduct = z.infer<typeof marketDemandProductSchema>;
